import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';
import { PortalApiService } from './portal-api.service';
import { ReportGroup } from '../_models/reports';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class PortalReportsService {
  private jobID = new BehaviorSubject<number>(null);
  private isLoadingReports = new BehaviorSubject<boolean>(false);
  private errorRetrievingReports = new BehaviorSubject<boolean>(false);
  private errorMessageReports = new BehaviorSubject<string>(null);
  private availableReports = new BehaviorSubject<ReportGroup[]>([]);
  private searchableReports = new BehaviorSubject<ReportGroup>(new ReportGroup());
  private favoriteReports = new BehaviorSubject<ReportGroup>(new ReportGroup());

  constructor(
    private apiService: PortalApiService
  ) {
  }

  jobID$ = this.jobID.asObservable();
  isLoadingReports$ = this.isLoadingReports.asObservable();
  availableReports$ = this.availableReports.asObservable();
  searchableReports$ = this.searchableReports.asObservable();
  favoriteReports$ = this.favoriteReports.asObservable();

  loadReportList() {
    let _searchableReports = new ReportGroup();
    let _favoriteReports = new ReportGroup();
    _searchableReports.reportGroup = "Total Reports";
    _searchableReports.reports = [];
    _favoriteReports.reportGroup = "Favorite Reports";
    _favoriteReports.reports = [];

    this.isLoadingReports.next(true);

    this.apiService.getReports().subscribe(
      (data: ReportGroup[]) => {
        data.map((reportGroup) => {
          for (var i = 0; i < reportGroup.reports.length; i++) {
            reportGroup.reports[i].favTogglePending = false;
            reportGroup.reports[i].reportGroup = reportGroup.reportGroup;
            reportGroup.reports[i].reportGroupID = reportGroup.reportGroupID;
            _searchableReports.reports = _searchableReports.reports.concat(_.cloneDeep(reportGroup.reports[i]));
            if (reportGroup.reports[i].isFavorite) {
              _favoriteReports.reports = _favoriteReports.reports.concat(_.cloneDeep(reportGroup.reports[i]));
            }
          }
        });

        _searchableReports.reports.sort(this.sortReportsByName);
        _favoriteReports.reports.sort(this.sortReportsByName);

        this.availableReports.next(data);
        this.favoriteReports.next(_favoriteReports);
        this.searchableReports.next(_searchableReports);

        this.isLoadingReports.next(false);
      },
      err => {
        console.log(err);
        this.errorMessageReports.next(err.message || 'An error occurred while retrieving the reports');
        this.errorRetrievingReports.next(true);
        this.isLoadingReports.next(false);
      })
  }

  updateAvailableReports(newAvailableReportsList: ReportGroup[]) {
    this.availableReports.next(newAvailableReportsList);
  }

  updateFavoriteReports(newFavoriteReportsGroup: ReportGroup) {
    this.favoriteReports.next(newFavoriteReportsGroup);
  }

  updateSearchableReports(newSearchableReportsGroup: ReportGroup) {
    this.searchableReports.next(newSearchableReportsGroup);
  }

  private sortReportsByName(a: any, b: any) {
    var nameA = a.reportName.toUpperCase();
    var nameB = b.reportName.toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  }
}
